import {client} from './services/client'

export  const userspharmacies = {
    namespaced:true,
    state:{
        userspharmacies:[],
    },
    mutations: {
        SET_USERPHARMACIE (state,userspharmacies){
            state.userspharmacies = userspharmacies
        },

    },
    actions: {
        getUsersPharmacie({commit},id){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'get',
                    url:'/userspharmacie/get/'+id,
                })
                    .then((response)=>{
                        let userspharmacies = response.data.userspharmacies;
                        console.log('userspharmacies');
                        console.log(userspharmacies);
                        commit('SET_USERPHARMACIE',userspharmacies);

                    })
                    .catch((error)=>{
                        reject(error);
                    })
            })

        },
        setUpdateUser({commit},data){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'post',
                    url:'/userspharmacie/update',
                    data:data,
                })
                    .then((response)=>{
                        let userspharmacies = response.data.userspharmacies;
                        commit('SET_USERPHARMACIE',userspharmacies);

                        resolve(response);
                    })
                    .catch((error)=>{
                        reject(error);
                    })
            });
        },
        setUser({commit},data){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'post',
                    url:'/userspharmacie/save',
                    data:data,
                })
                    .then((response)=>{
                        let userspharmacies = response.data.userspharmacies;
                        commit('SET_USERPHARMACIE',userspharmacies);

                        resolve(response);
                    })
                    .catch((error)=>{
                        reject(error);
                    })
            });
        },
        deleteUser({commit},id){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'get',
                    url:'/userspahrmacie/delete/'+id,
                })
                    .then((response)=>{
                        let userspharmacies = response.data.userspharmacies;
                        commit('SET_USERPHARMACIE',userspharmacies);
                    })
                    .catch((error)=>{
                        reject(error)
                    })
            })
        },
    },
    getters: {
        getUsersPharmacie: state  => {
            return state.userspharmacies
        },
    }
};
